mainApp.directive('tokenValidity', function() {
    return {
        templateUrl: '/public/directives/tokenValidity.html',
        scope: {
            cookieSettings: '=',
        },
         controller:  ['$scope', function($scope) {

     $scope.TokenDurationOptions = [
               {value: false,
               key: 'Always Prompt'
               },
               {value: true,
               key: 'Duration'
               }];

    $scope.CookieTimeUnitOptions = [
                 {value: 'DAYS',
                 key: 'Days'
                 },
                 {value: 'HOURS',
                 key: 'Hours'
                 }];
            }]
         }
    });
